import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import config from "../config";
import http from "../Services/httpService";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { getAppTimerMessages, loadAppTimerMessages } from "../app/store/messages";
import { getComponentUserStatus, UpdateComponentsUserStatus } from "../app/store/tools";
import { getCurrentUser } from "../app/store/auth";

const TimerPopup = ({ timerShowHide, handleTimerModalShowHide, workflowTask }) => {
  const [tmrMessages, setTmrMessages] = useState([]);

  const appTimerMessagesSelector = useSelector(getAppTimerMessages);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (workflowTask?.ciid > 0)
      dispatch(loadAppTimerMessages(workflowTask.ciid))
  }, [workflowTask]);

  useEffect(() => {
    setTmrMessages(appTimerMessagesSelector);
    if (appTimerMessagesSelector.length > 0) {
      let tmItems = "";
      appTimerMessagesSelector.map((x, key) => {
        if (key > 0) tmItems += ",";
        tmItems += x.tiid;
      });
      handleUpdateComponent(tmItems, workflowTask.ciid);
    }
  }, [appTimerMessagesSelector])

  const handleUpdateComponent = (compItems, ciid) => {
    const comp = componentUserStatusSelector.filter(x => x.compId === 27);
    let updCompItems = "";
    if (comp.length > 0) {
      updCompItems = comp[0].compItems;
    }
    const compObj = {
      compName: "Insurance Expiry",
      performerId: currentUser.id,
      compItems: compItems,
      ciid: ciid,
      wiid: 0,
      iiid: 0,
      compId: 27
    }
    if (compItems !== "" && compItems !== updCompItems) {
      dispatch(UpdateComponentsUserStatus(compObj));
    }
  }


  return (
    <Modal show={timerShowHide} size="xl">
      <Modal.Header closeButton onHide={handleTimerModalShowHide}>
        <Modal.Title>Timer Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-striped align-items-center table-flush border">
                <thead className="thead-light">
                  <tr>
                    <th>S.No.</th>
                    <th>Date & Time</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {tmrMessages.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <Moment format="MMM Do YYYY, h:mm a">
                          {item.endDateTime}
                        </Moment>
                      </td>
                      <td style={{ whiteSpace: "pre-wrap" }}>
                        {decodeURIComponent(item.message)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal.Body>
      {/* <Modal.Footer>
        <button className="btn btn-sm btn-outline-default" onClick={handleTimerModalShowHide}>
          <i className="fa fa-times" aria-hidden="true"></i> Close
        </button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default TimerPopup;
